<template>
  <v-expansion-panels v-model="value" :multiple="props.multiple">
    <slot />
  </v-expansion-panels>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
  modelValue?: number[];
  defaultOpened?: boolean;
  multiple?: boolean;
}>();

const value = ref(props.modelValue || []);

watch(
  () => props.defaultOpened,
  () => {
    if (props.defaultOpened) {
      value.value = [0];
    }
  },
  {
    immediate: true,
  },
);
</script>
